import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SmartSubTabBaseComponent } from '../../../../shared/components/smart-subtab-base.component';
import { ApplicationContextService } from '../../../../shared/services/application-context.service';
import { ApplicationConfigService } from '../../../../shared/services/application-config.service';

@Component({
  selector: 'app-devices',
  templateUrl: './devices.component.html',
  styleUrls: ['./devices.component.css']
})
export class DevicesComponent extends SmartSubTabBaseComponent implements OnInit {

  constructor(
    public route: ActivatedRoute,
    applicationContextService: ApplicationContextService,
    applicationConfigService: ApplicationConfigService
  ) {
    super(applicationContextService, applicationConfigService);
    this.parentTabName = 'Devices'; // Set the parent tab name
  }

  override ngOnInit() {
    super.ngOnInit(); // Initialize the smart sub-tab system
  }

  // You can override methods if needed for specific behavior
  onTabChange(index: number): string | undefined {
    return this.onSubTabChange(index); // Use the base class method
  }
}
